/* cookie banner - relabels Shopify's native "Manage preferences" button */

(function () {
  'use strict';

  var BUTTON_ID = 'shopify-pc__banner__btn-manage-prefs';
  var NEW_LABEL = 'Customize';

  function relabel(button) {
    var target = button.querySelector('span') || button;
    target.textContent = NEW_LABEL;
  }

  var existing = document.getElementById(BUTTON_ID);
  if (existing) {
    relabel(existing);
    return;
  }

  var observer = new MutationObserver(function () {
    var button = document.getElementById(BUTTON_ID);
    if (!button) return;
    relabel(button);
    observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
